import DOMPurify from 'dompurify';
import '../../styles/ckeditor.css';

interface EditorContentDisplayProps {
    content: string
}

export default function EditorContentDisplay({ content }: EditorContentDisplayProps) {
    const sanitizedContent = DOMPurify.sanitize(content);
    return (
        <div className='ck-editor'>
            <div className='ck-content' dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
        </div>
    );
}
